import { memo } from 'react';
import { LocalesEnum } from 'src/generated/operations.ts';
import { DECIMAL_DIGITS } from 'src/modules/common/constants.ts';

type PriceProps = {
    price: number;
    currency: string;
    locale: LocalesEnum;
}

export const Price = memo(({ currency, locale, price }: PriceProps) => {
    try {
        const localeName = locale.replace('_', '-');
        return new Intl.NumberFormat(
            Intl.NumberFormat.supportedLocalesOf([localeName]).length === 1 ? localeName : locale.substring(0, 2),
            { style: 'currency', currency, maximumFractionDigits: DECIMAL_DIGITS },
        )
            .format(price);
    } catch {
        return `${price.toFixed(DECIMAL_DIGITS)} ${currency}`;
    }
});
